
export default function DeleteButtonDirective() {
    'ngInject';
    return {
        template: require('./delete-button.html'),
        transclude: true,
        restrict: 'E'
    };
}
